import { render } from "./CrmSummaryCards.vue?vue&type=template&id=6e40f11e&scoped=true"
import script from "./CrmSummaryCards.vue?vue&type=script&lang=js"
export * from "./CrmSummaryCards.vue?vue&type=script&lang=js"

import "./CrmSummaryCards.vue?vue&type=style&index=0&id=6e40f11e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e40f11e"]])

export default __exports__